<script>
    import { Route, Link, Router } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import Financial_4Home from './home/financial-4-home.svelte'
    import Financial_4Pos from './accounts-pos/financial-4-pos.svelte'
    import Financial_4BillsToPay from './bills/financial-4-bills-to-pay.svelte'
    import Financial_4Accounts from './accounts/financial-4-accounts.svelte'
    import Financial_4BillsToReceive from './bills/financial-4-bills-to-receive.svelte'
    import Financial_4RelatResult from './result/financial-4-relat-result.svelte'
    import { onMount } from 'svelte'
    import Financial_4Report from './report/financial-4-report.svelte'

    let tabs = [
        {
            title: 'Financeiro',
            url: '/financial-4/home',
        },
        {
            title: 'A receber',
            url: '/financial-4/bills-to-receive',
        },
        {
            title: 'A pagar',
            url: '/financial-4/bills-to-pay',
        },
        {
            title: 'PDV',
            url: '/financial-4/pos',
        },
        {
            title: 'Movimentação',
            url: '/financial-4/accounts',
        },
        {
            title: 'Relatórios',
            url: '/financial-4/reports',
        },
        {
            spacer: true,
        },
    ]

    onMount(async () => {})
</script>

<div class="root-content">
    <Ztab {tabs} class="h-space" />
    <Router>
        <Route path="/home">
            <!-- <Financial_4Home></Financial_4Home> -->
            <Financial_4RelatResult></Financial_4RelatResult>
        </Route>
        <Route path="/bills-to-pay">
            <Financial_4BillsToPay></Financial_4BillsToPay>
        </Route>
        <Route path="/bills-to-receive">
            <Financial_4BillsToReceive></Financial_4BillsToReceive>
        </Route>
        <Route path="/pos">
            <Financial_4Pos></Financial_4Pos>
        </Route>
        <Route path="/accounts">
            <Financial_4Accounts></Financial_4Accounts>
        </Route>
        <Route path="/results">
            <Financial_4RelatResult></Financial_4RelatResult>
        </Route>
        <Route path="/reports">
            <Financial_4Report></Financial_4Report>
        </Route>
    </Router>
</div>
